export default __webpack_public_path__ + "static/media/product3.09f36540.webp";